module.exports = __webpack_public_path__ + "static/img/product-thumb-cars2.11ec2c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/design/product-thumb-cars2.png
// module id = cao8
// module chunks = 13